var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'app-standalone': _vm.isStandalonePage },attrs:{"id":"app"}},[(!_vm.isStandalonePage)?_c('nav-bar'):_vm._e(),_c('router-view'),(!_vm.isStandalonePage)?_c('bottom'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }